import React from 'react';

export function ProductManuals() {
	return (
		<div className="container-fluid">
			<h1>Product Manuals</h1>
		</div>
	);
}